[
  {
    "id": "crafting-blueprint",
    "category": "special",
    "name": "Crafting Blueprint",
    "description": "Reveals one valid recipe shape for the current round without showing which ingredients belong in the hinted slots.",
    "rarity": "rare",
    "coinPrice": 150
  },
  {
    "id": "freeze",
    "category": "special",
    "name": "Freeze",
    "description": "Freezes both crafting tables and inventories for five seconds, pausing the round clock so you have more time to study the recipe.",
    "rarity": "rare",
    "coinPrice": 150
  },
  {
    "id": "scramble",
    "category": "special",
    "name": "Scramble",
    "description": "Randomizes the opponent's inventory slots, forcing them to quickly find their crafting items again.",
    "rarity": "uncommon",
    "coinPrice": 80
  }
]
